import {
  FaBalanceScale,
  FaChartArea,
  FaChartBar,
  FaChartLine,
  FaChartPie,
  FaClipboardList,
  FaCogs,
  FaDatabase,
  FaFile,
  FaFileInvoice,
  FaGlobe,
  FaLayerGroup,
  FaLightbulb,
  FaMoneyBillWave,
  FaRobot,
  FaShieldAlt,
  FaSortAmountDown,
  FaSortAmountUp,
  FaTag,
  FaUserTie,
} from "react-icons/fa";

export const ICON_MAP = {
  FaChartBar,
  FaCogs,
  FaChartArea,
  FaMoneyBillWave,
  FaChartLine,
  FaChartPie,
  FaShieldAlt,
  FaRobot,
  FaLightbulb,
  FaDatabase,
  FaFile,
  FaClipboardList,
  FaBalanceScale,
  FaGlobe,
  FaTag,
  FaLayerGroup,
  FaUserTie,
  FaFileInvoice,
  FaSortAmountDown,
  FaSortAmountUp,
};

export const REPORT_ICON_NAMES = {
  verticalBalance: "FaChartBar",
  horizontalBalance: "FaChartLine",
  verticalIncome: "FaChartLine",
  cashFlow: "FaMoneyBillWave",
  trend: "FaChartLine",
  workingCapital: "FaMoneyBillWave",
  profitability: "FaChartPie",
  liquidity: "FaMoneyBillWave",
  solvency: "FaShieldAlt",
  activity: "FaCogs",
  efficiency: "FaCogs",
  expense: "FaChartBar",
  revenue: "FaChartBar",
  general: "FaChartArea",
};

export const REPORT_COLORS = {
  verticalBalance: "blue",
  horizontalBalance: "blue",
  verticalIncome: "green",
  cashFlow: "green",
  trend: "purple",
  workingCapital: "orange",
  profitability: "green",
  liquidity: "blue",
  solvency: "red",
  activity: "purple",
  efficiency: "teal",
  expense: "red",
  revenue: "green",
  general: "cyan",
};
